module.exports = __webpack_public_path__ + "429fecf5a04ae41328dbb718849d65f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/abbvie_2023_chart.png
// module id = 1620
// module chunks = 0